import { getUserAgentString } from "./utils.mjs";
var BROWSER_TYPE = /* @__PURE__ */ ((BROWSER_TYPE2) => {
  BROWSER_TYPE2["UNKNOWN"] = "UNKNOWN";
  BROWSER_TYPE2["WEB"] = "WEB";
  BROWSER_TYPE2["WAVE"] = "WAVE";
  BROWSER_TYPE2["PAYWEB"] = "PAYWEB";
  BROWSER_TYPE2["BIZWEB"] = "BIZWEB";
  return BROWSER_TYPE2;
})(BROWSER_TYPE || {});
var EXTENSION_TYPE = /* @__PURE__ */ ((EXTENSION_TYPE2) => {
  EXTENSION_TYPE2["BASE"] = "BASE";
  EXTENSION_TYPE2["HOME"] = "HOME";
  EXTENSION_TYPE2["BOTTOM"] = "BOTTOM";
  EXTENSION_TYPE2["CONTENTS"] = "CONTENTS";
  EXTENSION_TYPE2["TRANSPARENT"] = "TRANSPARENT";
  EXTENSION_TYPE2["HIDE"] = "HIDE";
  EXTENSION_TYPE2["TAB"] = "TAB";
  return EXTENSION_TYPE2;
})(EXTENSION_TYPE || {});
var APP_TYPE = /* @__PURE__ */ ((APP_TYPE2) => {
  APP_TYPE2["UNKNOWN"] = "UNKNOWN";
  APP_TYPE2["KAKAOTALK"] = "KAKAOTALK";
  APP_TYPE2["KAKAOPAY"] = "KAKAOPAY";
  APP_TYPE2["KAKAOPAY_BIZ"] = "KAKAOPAY_BIZ";
  return APP_TYPE2;
})(APP_TYPE || {});
const APP_VERSION_REGEXPS = {
  kakaotalk: /KT\/([\d]+.[\d]+.[\d]+)/i,
  pay: /PAYAPP\/([\d]+.[\d]+.[\d]+)/i,
  paybiz: /PARTNERAPP\/([\d]+.[\d]+.[\d]+)/i
};
function checkBrowser(userAgent) {
  const agent = getUserAgentString(userAgent);
  if (isKakao(agent)) {
    if (isWaveWebview(agent)) {
      return "WAVE";
    }
    if (isPayWebview(agent)) {
      return "PAYWEB";
    }
    return "WEB";
  }
  if (isBizWebview(agent)) {
    return "BIZWEB";
  }
  return "UNKNOWN";
}
function checkApp(userAgent) {
  const agent = getUserAgentString(userAgent);
  if (/PAYAPP\//.test(agent)) {
    return "KAKAOPAY";
  } else if (/KT\//.test(agent)) {
    return "KAKAOTALK";
  } else if (/PARTNERAPP\//.test(agent)) {
    return "KAKAOPAY_BIZ";
  }
  return "UNKNOWN";
}
function checkExtension(userAgent) {
  if (isFragmentWebview(userAgent)) {
    return "HOME";
  }
  if (isBottomSheetWebview(userAgent)) {
    return "BOTTOM";
  }
  if (isContentsWebview(userAgent)) {
    return "CONTENTS";
  }
  if (isTransparentNavigationWebview(userAgent)) {
    return "TRANSPARENT";
  }
  if (isHiddenNavigationWebview(userAgent)) {
    return "HIDE";
  }
  if (isTabWebview(userAgent)) {
    return "TAB";
  }
  return "BASE";
}
function isKakaoPayApp(userAgent) {
  return checkApp(userAgent) === "KAKAOPAY";
}
function isKakaoTalkApp(userAgent) {
  return checkApp(userAgent) === "KAKAOTALK";
}
function isKakaoPayBizApp(userAgent) {
  return checkApp(userAgent) === "KAKAOPAY_BIZ";
}
function getAppVersion(userAgent) {
  const agent = getUserAgentString(userAgent);
  if (checkApp(agent) === "KAKAOPAY") {
    return agent.match(APP_VERSION_REGEXPS.pay)[1];
  } else if (checkApp(agent) === "KAKAOTALK") {
    return agent.match(APP_VERSION_REGEXPS.kakaotalk)[1];
  } else if (checkApp(agent) === "KAKAOPAY_BIZ") {
    return agent.match(APP_VERSION_REGEXPS.paybiz)[1];
  }
  return "0.0.0";
}
function isPayWebview(userAgent) {
  const agent = getUserAgentString(userAgent);
  return /PAY\/WEB/.test(agent);
}
function isBizWebview(userAgent) {
  const agent = getUserAgentString(userAgent);
  return /BIZ\/WEB/.test(agent);
}
function isWaveWebview(userAgent) {
  const agent = getUserAgentString(userAgent);
  return /WAVE/.test(agent);
}
function isKakao(userAgent, exceptPayApp = false) {
  const agent = getUserAgentString(userAgent);
  const isKakao2 = new RegExp(`(${exceptPayApp ? "" : "PAYAPP|"}KAKAOTALK|KT)`, "i").test(
    agent
  );
  return isKakao2;
}
function isKakaoPayWebview(userAgent) {
  const agent = getUserAgentString(userAgent);
  return APP_VERSION_REGEXPS.kakaotalk.test(agent) || APP_VERSION_REGEXPS.pay.test(agent);
}
function isFragmentWebview(userAgent) {
  const agent = getUserAgentString(userAgent);
  return /TYPE\/HOME/.test(agent);
}
function isBottomSheetWebview(userAgent) {
  const agent = getUserAgentString(userAgent);
  return /TYPE\/BOTTOM/.test(agent);
}
function isContentsWebview(userAgent) {
  const agent = getUserAgentString(userAgent);
  return /TYPE\/CONTENTS/.test(agent);
}
function isTransparentNavigationWebview(userAgent) {
  const agent = getUserAgentString(userAgent);
  return /TYPE\/TRANSPARENT/.test(agent);
}
function isHiddenNavigationWebview(userAgent) {
  const agent = getUserAgentString(userAgent);
  return /TYPE\/HIDE/.test(agent);
}
function isTabWebview(userAgent) {
  const agent = getUserAgentString(userAgent);
  return /TYPE\/TAB/.test(agent);
}
function getTabIndex(userAgent) {
  const agent = getUserAgentString(userAgent);
  const reg = /TAB\/([0-9]{1})/;
  const matches = reg.exec(agent);
  return Number((matches == null ? void 0 : matches[1]) ?? 0);
}
function isFacebookTwitterBot(userAgent) {
  const agent = getUserAgentString(userAgent).toLocaleLowerCase();
  return /facebookexternalhi|facebookexternalhit|twitterbot/i.test(agent);
}
function isBot(userAgent) {
  const agent = getUserAgentString(userAgent).toLocaleLowerCase();
  return /facebookexternalhi|twitterbot|facebookexternalhit|googlebot|bingbot|naverbot|daumoa|kakaotalk-scrap|Yeti|Slackbot/i.test(
    agent
  );
}
function isKakaoBot(userAgent) {
  const agent = getUserAgentString(userAgent).toLocaleLowerCase();
  return /facebookexternalhi|facebookexternalhit|twitterbot|kakaotalk-scrap/i.test(agent);
}
function isMobile(userAgent) {
  const agent = getUserAgentString(userAgent).toLocaleLowerCase();
  return /mobile|android|An\/|ios|iphone|ipad|Io\//i.test(agent);
}
function isPc(userAgent) {
  return !isMobile(userAgent);
}
function isBrowser() {
  return typeof window !== "undefined";
}
function isServer() {
  return typeof window === "undefined";
}
function getBrowserInfo(userAgent) {
  return {
    browserType: checkBrowser(userAgent),
    appType: checkApp(userAgent),
    extension: checkExtension(userAgent),
    appVersion: getAppVersion(userAgent),
    tabIndex: getTabIndex(userAgent),
    isFacebookTwitterBot: isFacebookTwitterBot(userAgent),
    isBot: isBot(userAgent),
    isKakaoBot: isKakaoBot(userAgent),
    isMobile: isMobile(userAgent),
    isPc: isPc(userAgent)
  };
}
export {
  APP_TYPE,
  BROWSER_TYPE,
  EXTENSION_TYPE,
  checkApp,
  checkBrowser,
  checkExtension,
  getAppVersion,
  getBrowserInfo,
  getTabIndex,
  isBizWebview,
  isBot,
  isBottomSheetWebview,
  isBrowser,
  isContentsWebview,
  isFacebookTwitterBot,
  isFragmentWebview,
  isHiddenNavigationWebview,
  isKakao,
  isKakaoBot,
  isKakaoPayApp,
  isKakaoPayBizApp,
  isKakaoPayWebview,
  isKakaoTalkApp,
  isMobile,
  isPayWebview,
  isPc,
  isServer,
  isTabWebview,
  isTransparentNavigationWebview,
  isWaveWebview
};
